import request from '@/utils/request'

// 采购列表
export function fetchList(params) {
	return request({
		url: '/scm/goods/demand/list',
		method: 'get',
		params
	})
}

// 生成采购单
export function generateOrder(data) {
	return request({
		url: '/scm/goods/demand/purOrder/generate',
		method: 'post',
		data
	})
}

// 生成采购单
export function combineGenerateOrder(data) {
	return request({
		url: '/scm/goods/demand/combine/generate/',
		method: 'post',
		data
	})
}

// 领取采购需求
export function recipients(data) {
	return request({
		url: '/scm/goods/demand/recipients',
		method: 'post',
		data
	})
}

// 已领取采购需求
export function receivedList(params) {
	return request({
		url: '/scm/goods/demand/received/list',
		method: 'get',
		params
	})
}

// 释放采购需求
export function releasePurchase(data) {
	return request({
		url: '/scm/goods/demand/release',
		method: 'post',
		data
	})
}

// 标记问题单
export function mark(data) {
	return request({
		url: '/scm/goods/demand/mark/problem',
		method: 'post',
		data
	})
}

// 模糊查询供应商 /scm/supplier/search
export function supplierSearch(params) {
	return request({
		url: '/scm/supplier/search',
		method: 'get',
		params
	})
}

/**
 * 仓库列表
 */
export function listDepot() {
	return request({
		url: '/oms/wms/depot/list',
		method: 'post',
	})
}



// WEBPACK FOOTER //
// ./src/api/pcm/purchase.js